module.exports = __webpack_public_path__ + "img/Maria-Vazquez-website.cada2bc7.jpeg";